import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-category-carousel',
  standalone: false,
  templateUrl: './category-carousel.html',
  styleUrl: './category-carousel.less'
})
export class CategoryCarousel {
  @Output() selectCategory = new EventEmitter<any>();


  updateArticleByCategory(category:any){
    this.selectCategory.emit(category);
  }

}
